import OtpCheck from './otp-check';

export default OtpCheck;

export {
    OtpCheck
}
